import { useContext } from "react";

import { AuthContext } from "./AuthContext";
import { PermissionScope, PERMISSION_SCOPES } from "./types";

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  // Add a convenience getter for the email
  const getOperatorEmail = (): string | null => {
    return context.operator?.email ?? null;
  };

  // Add a convenience getter for the email
  const getOperatorPermissionScope = (): PermissionScope =>
    context.operator?.permissionScope ?? PERMISSION_SCOPES.INVALID;

  const getOperatorName = (): string | null => {
    return context.operator?.name ?? null;
  };

  // Add a convenience permission scope check
  const hasOperatorPermissionScope = (scopes: PermissionScope[]): boolean =>
    scopes.includes(getOperatorPermissionScope());

  return {
    ...context,
    getOperatorName,
    getOperatorEmail,
    getOperatorPermissionScope,
    hasOperatorPermissionScope,
  };
};
